<template>
    <div height="medium" width="large">
        <div class="container">
            <div class="Cards">
                <div class="main-data main-card">
                    <div>
                        <common-icon name="user" size="medium"></common-icon>
                        <span class="card-title">
                            {{ $t('modals.patient_profile.profile.card_head') }}
                        </span>
                    </div>
                    <div class="edit-export">
                        <common-icon name="edit" size="medium" @click="editEnable('profile')"></common-icon>
                        <input
                            v-if="isExportProfileClicked"
                            v-model="selectedExportFields.profile"
                            type="checkbox"
                            class="export-checkbox"
                        />
                    </div>
                </div>
                <form-wrapper @submit="handleFormSubmission()">
                    <form-row>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.full_name.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.full_name.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :formData="data"
                                valuePath="fullName"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.dob.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.dob.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="dob"
                                type="date"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.gender.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.gender.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="gender"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>
                    <form-row>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.marital_status.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.marital_status.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :formData="data"
                                valuePath="maritalStatus"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.language.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.language.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="language"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.ssn.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.ssn.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="ssn"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>

                    <div v-if="isProfileEditable">
                        <common-buttons style="margin-top: 20px">
                            <common-button
                                :isSubmittable="false"
                                :label="$t('pages.patient.details.buttons.secondary')"
                                type="secondary"
                                @click="handleCancel"
                            ></common-button>
                            <common-button
                                :isProcessing="isSending"
                                :label="$t('pages.patient.details.buttons.primary')"
                                type="primary"
                            ></common-button>
                        </common-buttons>
                    </div>
                </form-wrapper>
            </div>
            <div class="Cards">
                <div class="main-data main-card">
                    <div>
                        <common-icon name="phone" size="medium"></common-icon>
                        <span class="card-title">{{ $t('modals.patient_profile.profile.contact_info.card_head') }}</span>
                    </div>
                    <div class="edit-export">
                        <common-icon name="edit" size="medium" @click="editEnable('contact')"></common-icon>
                        <input
                            v-if="isExportProfileClicked"
                            v-model="selectedExportFields.contact"
                            type="checkbox"
                            class="export-checkbox"
                        />
                    </div>
                </div>
                <form-wrapper @submit="handleFormSubmission()">
                    <form-row>
                        <form-cell width="half">
                            <phone-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.primary_phone.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.primary_phone.placeholder')"
                                :isDisabled="!isContactEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="mobilePhone"
                                type="number"
                                @change="change($event)"
                            ></phone-field>
                        </form-cell>
                        <form-cell width="half">
                            <form-cell v-if="isContactEditable" width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.contact_info.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.contact_info.placeholder')"
                                    :isDisabled="!isContactEditable"
                                    :formData="data"
                                    valuePath="preferredContactMethod"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <div v-else class="col">
                                <p class="label">
                                    {{ $t('modals.patient_profile.profile.contact_info.preferred_method') }}
                                    <span class="badge">
                                        {{ $t('modals.patient_profile.profile.contact_info.preferred_method_value') }}
                                    </span>
                                </p>
                            </div>
                        </form-cell>
                    </form-row>

                    <form-row>
                        <form-cell width="half">
                            <phone-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.alternate_phone.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.alternate_phone.placeholder')"
                                :isDisabled="!isContactEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="homePhone"
                                type="number"
                                @change="change($event)"
                            ></phone-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.email.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.email.placeholder')"
                                :isDisabled="!isContactEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="email"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>

                    <div v-if="isContactEditable">
                        <common-buttons style="margin-top: 20px">
                            <common-button
                                :isSubmittable="false"
                                :label="$t('pages.patient.details.buttons.secondary')"
                                type="secondary"
                                @click="handleCancel"
                            ></common-button>
                            <common-button
                                :isProcessing="isSending"
                                :label="$t('pages.patient.details.buttons.primary')"
                                type="primary"
                            ></common-button>
                        </common-buttons>
                    </div>
                </form-wrapper>
            </div>
            <section class="Cards">
                <div class="main-data main-card">
                    <div>
                        <common-icon name="location" size="medium"></common-icon>
                        <span class="card-title">{{ $t('modals.patient_profile.profile.address.card_head') }}</span>
                    </div>
                    <div class="edit-export">
                        <common-icon name="edit" size="medium" @click="editEnable('address')"></common-icon>
                        <input
                            v-if="isExportProfileClicked"
                            v-model="selectedExportFields.address"
                            type="checkbox"
                            class="export-checkbox"
                        />
                    </div>
                </div>

                <form-wrapper @submit="handleFormSubmission()">
                    <form-row>
                        <form-cell :width="!isAddressEditable ? 'half' : undefined">
                            <suggest-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.address.street.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.address.street.placeholder')"
                                :suggestionsCall="addressSuggestionCall"
                                :isRequired="true"
                                :isDisabled="!isAddressEditable"
                                :isSuggested="false"
                                :formData="data"
                                valuePath="address"
                                @change="change($event)"
                                @select="changeLocationAddress($event)"
                            ></suggest-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.address.state.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.address.state.placeholder')"
                                :isDisabled="!isAddressEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="state"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>
                    <form-row>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.address.city.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.address.city.placeholder')"
                                :isDisabled="!isAddressEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="city"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.address.zip.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.address.zip.placeholder')"
                                :isDisabled="!isAddressEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="zip"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>

                    <div v-if="isAddressEditable">
                        <common-buttons style="margin-top: 20px">
                            <common-button
                                :isSubmittable="false"
                                :label="$t('pages.patient.details.buttons.secondary')"
                                type="secondary"
                                @click="handleCancel"
                            ></common-button>
                            <common-button
                                :isProcessing="isSending"
                                :label="$t('pages.patient.details.buttons.primary')"
                                type="primary"
                            ></common-button>
                        </common-buttons>
                    </div>
                </form-wrapper>
            </section>

            <section class="Cards">
                <div class="main-data main-card">
                    <div>
                        <common-icon name="emergancy" size="medium"></common-icon>
                        <span class="card-title">{{ $t('modals.patient_profile.profile.emergency.card_head') }}</span>
                    </div>
                    <div>
                        <common-icon
                            v-if="!hasEmergencyContact(data)"
                            name="add-user"
                            size="medium"
                            @click="editEnable('emergency')"
                        ></common-icon>
                    </div>
                    <div class="edit-export">
                        <common-icon
                            v-if="hasEmergencyContact(data)"
                            name="edit"
                            size="medium"
                            @click="editEnable('emergency')"
                        ></common-icon>
                        <input
                            v-if="isExportProfileClicked"
                            v-model="selectedExportFields.emergency"
                            type="checkbox"
                            class="export-checkbox"
                        />
                    </div>
                </div>

                <div>
                    <div v-if="isEmergencyEditable" class="contact-card">
                        <form-wrapper @submit="handleFormSubmission()">
                            <form-row>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.first_name.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.first_name.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.firstName"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.last_name.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.last_name.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.lastName"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                            </form-row>
                            <form-row>
                                <form-cell width="half">
                                    <phone-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.phone.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.phone.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :isRequired="false"
                                        :formData="data"
                                        valuePath="emergencyContact.phone"
                                        type="number"
                                        @change="change($event)"
                                    ></phone-field>
                                </form-cell>

                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.email.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.email.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.email"
                                        type="email"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>

                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.relationship.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.relationship.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.relationship"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                            </form-row>
                            <div v-if="isEmergencyEditable">
                                <common-buttons style="margin-top: 20px">
                                    <common-button
                                        :isSubmittable="false"
                                        :label="$t('pages.patient.details.buttons.secondary')"
                                        type="secondary"
                                        @click="handleCancel"
                                    ></common-button>
                                    <common-button
                                        :isProcessing="isSending"
                                        :label="$t('pages.patient.details.buttons.primary')"
                                        type="primary"
                                    ></common-button>
                                </common-buttons>
                            </div>
                        </form-wrapper>
                    </div>
                    <div v-if="hasEmergencyContact(data)" class="contact-card">
                        <div class="main">
                            <p class="name">{{ data?.emergencyContact?.firstName }} {{ data?.emergencyContact?.lastName }}</p>
                            <div class="">
                                <span class="tag">{{ data?.emergencyContact?.relationship }}</span>
                                <span class="tag primary">Primary</span>
                            </div>
                        </div>
                        <div class="card_grid">
                            <p class="port">
                                <common-icon name="phone" size="tiny"></common-icon>
                                {{ data?.emergencyContact?.phone }}
                            </p>
                            <p class="port">
                                <common-icon name="email" size="tiny"></common-icon>
                                {{ data?.emergencyContact?.email }}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section class="Cards">
                <div class="main-data main-card">
                    <div>
                        <common-icon name="link" size="medium"></common-icon>
                        <span class="card-title">{{ $t('modals.patient_profile.profile.pharmacy.card_head') }}</span>
                    </div>
                    <div class="edit-export">
                        <common-icon name="edit" size="medium" @click="editEnable('pharmacy')"></common-icon>
                        <input
                            v-if="isExportProfileClicked"
                            v-model="selectedExportFields.pharmacy"
                            type="checkbox"
                            class="export-checkbox"
                        />
                    </div>
                </div>
                <div class="contact-card">
                    <form-wrapper v-if="isPharmacyEditable" @submit="handleFormSubmission()">
                        <form-row>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.pharmacy.name.lable')"
                                    :placeholder="$t('forms.patient_profile.fields.pharmacy.name.placeholder')"
                                    :isDisabled="!isPharmacyEditable"
                                    :formData="data"
                                    valuePath="pharmacyName"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                        </form-row>
                        <form-row>
                            <form-cell :width="!isPharmacyEditable ? 'half' : undefined">
                                <suggest-field
                                    class="patient-detail-form-text"
                                    :placeholder="$t('forms.patient_profile.fields.pharmacy.address.placeholder')"
                                    :suggestionsCall="addressSuggestionCall"
                                    :isRequired="true"
                                    :isDisabled="!isPharmacyEditable"
                                    :isSuggested="false"
                                    :formData="data"
                                    valuePath="pharmacyAddress"
                                    @change="change($event)"
                                    @select="changeLocationAddress($event)"
                                ></suggest-field>
                            </form-cell>
                        </form-row>
                        <form-row>
                            <form-cell width="half">
                                <phone-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.pharmacy.phone.lable')"
                                    :placeholder="$t('forms.patient_profile.fields.pharmacy.phone.placeholder')"
                                    :isDisabled="!isPharmacyEditable"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="pharmacyPhone"
                                    type="number"
                                    @change="change($event)"
                                ></phone-field>
                            </form-cell>

                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.pharmacy.fax.lable')"
                                    :placeholder="$t('forms.patient_profile.fields.pharmacy.fax.placeholder')"
                                    :isDisabled="!isPharmacyEditable"
                                    :formData="data"
                                    valuePath="fax"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                        </form-row>
                        <div v-if="isPharmacyEditable">
                            <common-buttons style="margin-top: 20px">
                                <common-button
                                    :isSubmittable="false"
                                    :label="$t('pages.patient.details.buttons.secondary')"
                                    type="secondary"
                                    @click="handleCancel"
                                ></common-button>
                                <common-button
                                    :isProcessing="isSending"
                                    :label="$t('pages.patient.details.buttons.primary')"
                                    type="primary"
                                ></common-button>
                            </common-buttons>
                        </div>
                    </form-wrapper>
                    <div v-else>
                        <div class="main">
                            <p class="name">{{ $t('modals.patient_profile.profile.pharmacy.name') }}</p>
                            <span class="tag green">Preferred</span>
                        </div>

                        <p class="port">
                            <common-icon name="location" size="small"></common-icon>
                            {{ $t('modals.patient_profile.profile.pharmacy.address') }}
                        </p>

                        <div class="card_grid">
                            <p class="port">
                                <common-icon name="phone" size="tiny"></common-icon>
                                {{ $t('modals.patient_profile.profile.pharmacy.phone') }}
                            </p>
                            <p class="port">
                                <common-icon name="file" size="tiny"></common-icon>
                                {{ $t('modals.patient_profile.profile.pharmacy.fax') }}
                            </p>
                        </div>

                        <p class="port">
                            <common-icon name="timer" size="small"></common-icon>
                            {{ $t('modals.patient_profile.profile.pharmacy.hours') }}
                        </p>
                    </div>
                </div>
            </section>

            <section class="Cards">
                <div class="main-data">
                    <div class="title-group">
                        <common-icon name="building" size="medium"></common-icon>
                        <h3 class="card-title">{{ $t('modals.patient_profile.profile.providers.card_head') }}</h3>
                    </div>
                    <input
                        v-if="isExportProfileClicked"
                        v-model="selectedExportFields.providers"
                        type="checkbox"
                        class="export-checkbox"
                    />
                </div>
                <div v-for="(connection, index) in connections" :key="index" class="contact-card">
                    <p class="user-name">{{ connectionName(connection) }}</p>
                    <div class="main">
                        <p class="label">
                            <span v-if="connection?.user">
                                {{ connection?.user?.specialities[0]?.speciality.name }}
                            </span>
                        </p>
                        <div class="">
                            <span class="tag primary">{{ $t('modals.patient_profile.profile.providers.primary') }}</span>
                            <span class="tag green">{{ $t('modals.patient_profile.profile.providers.in_network') }}</span>
                        </div>
                    </div>
                    <p class="port">{{ connection.practice.name }}</p>
                    <div class="card_grid">
                        <p class="port">
                            <common-icon name="phone" size="tiny"></common-icon>
                            {{ connectionPhone(connection) }}
                        </p>
                        <p class="port">
                            <common-icon name="email" size="tiny"></common-icon>
                            {{ connectionEmail(connection) }}
                        </p>
                    </div>
                    <p class="port">
                        <common-icon name="location" size="small"></common-icon>
                        {{ connectionAddress(connection) }}
                    </p>
                </div>
            </section>

            <div v-if="isExportProfileClicked" class="export-desc">
                <p>{{ $t('pages.patient.details.text.export_txt') }}</p>
                <common-buttons>
                    <common-button
                        :isSubmittable="false"
                        :label="$t('pages.patient.details.buttons.secondary')"
                        type="secondary"
                        @click="handleCancelExport"
                    ></common-button>
                    <common-button
                        :isDisabled="!hasSelectedFields"
                        :label="$t('pages.patient.details.buttons.export')"
                        type="primary"
                        @click="openExportModal"
                    ></common-button>
                </common-buttons>
            </div>
            <div class="main-data">
                <button class="btn" @click="exportBtnClick">
                    <common-icon name="file" size="tiny"></common-icon>
                    {{ $t('pages.patient.details.buttons.export_profile') }}
                </button>
                <button class="btn">
                    <common-icon name="setting" size="tiny"></common-icon>
                    {{ $t('pages.patient.details.buttons.edit_profile') }}
                </button>
            </div>
        </div>
        <common-modal v-if="isExportModalOpen" :isOpen="isExportModalOpen" width="large" height="full" @close="closeExportModal">
            <download-profile
                :patientDetails="patientDetails"
                :exportData="buildExportData()"
                @download-pdf="closeExportModalAndClear"
            ></download-profile>
        </common-modal>
    </div>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PatientAPI from 'api/PatientAPI'
    import isEqual from 'lodash.isequal'
    import FormDisableableMixin from 'mixins/FormDisableableMixin'
    import DownloadProfile from '../../page-elements/DownloadProfile.vue'

    export default {
        mixins: [FormMixin, HandleRequestMixin, FormDisableableMixin],

        components: { DownloadProfile },

        props: {
            patientDetails: { type: Object, required: true },
        },

        data() {
            return {
                isProfileEditable: false,
                isContactEditable: false,
                isAddressEditable: false,
                isEmergencyEditable: false,
                isPharmacyEditable: false,
                maxNumberOfItems: null,
                changedFields: {},
                connections: [],
                isExportProfileClicked: false,
                isExportModalOpen: false,
                selectedExportFields: {
                    profile: false,
                    contact: false,
                    address: false,
                    emergency: false,
                    pharmacy: false,
                    providers: false,
                    preferences: false,
                    healthcare: false,
                },
            }
        },

        computed: {
            hasSelectedFields() {
                return Object.values(this.selectedExportFields).some(Boolean)
            },
            addressSuggestionCall() {
                //eslint-disable-next-line no-undef
                const autocompleteService = new google.maps.places.AutocompleteService()
                return (query) => {
                    const request = {
                        input: query,
                        componentRestrictions: { country: 'US' },
                    }
                    return autocompleteService.getPlacePredictions(request).then((results) => {
                        return results?.predictions?.map((item) => {
                            return {
                                label: item.description,
                                value: item.place_id,
                            }
                        })
                    })
                }
            },
        },

        methods: {
            exportBtnClick() {
                this.isExportProfileClicked = true
            },
            handleCancelExport() {
                this.isExportProfileClicked = false
                this.resetSelectedExportFields()
            },
            openExportModal() {
                this.isExportModalOpen = true
            },
            closeExportModal() {
                this.isExportModalOpen = false
            },
            closeExportModalAndClear() {
                this.handleCancelExport()
                this.closeExportModal()
            },
            resetSelectedExportFields() {
                Object.keys(this.selectedExportFields).forEach((key) => {
                    this.selectedExportFields[key] = false
                })
            },
            buildExportData() {
                const exportData = {}

                if (this.selectedExportFields.profile) {
                    exportData.Profile = {
                        Name: this.data.fullName,
                        DOB: this.data.dob,
                        Gender: this.data.gender,
                        MaritalStatus: this.data.maritalStatus,
                        Language: this.data.language,
                        SSN: this.data.ssn,
                    }
                }

                if (this.selectedExportFields.contact) {
                    exportData.Contact = {
                        Mobile: this.data.mobilePhone,
                        ContactMethod: this.data.preferredContactMethod,
                        Home: this.data.homePhone,
                        Email: this.data.email,
                    }
                }

                if (this.selectedExportFields.address) {
                    exportData.Address = {
                        Address: this.data.address,
                        City: this.data.city,
                        State: this.data.state,
                        Zip: this.data.zip,
                    }
                }

                if (this.selectedExportFields.emergency) {
                    exportData.EmergencyContact = {
                        Name: `${this.data.emergencyContact.firstName} ${this.data.emergencyContact.lastName}`,
                        Phone: this.data.emergencyContact.phone,
                        Email: this.data.emergencyContact.email,
                        Relationship: this.data.emergencyContact.relationship,
                    }
                }

                if (this.selectedExportFields.pharmacy) {
                    exportData.PreferredPharmacy = {
                        Name: this.data.pharmacyName,
                        Address: this.data.pharmacyAddress,
                        Phone: this.data.pharmacyPhone,
                        Fax: this.data.fax,
                    }
                }
                if (this.selectedExportFields.providers) {
                    exportData.Providers = this.connections.map((connection) => ({
                        Name: this.connectionName(connection),
                        Speciality: connection?.user?.specialities?.[0]?.speciality?.name || 'N/A',
                        Practice: connection?.practice?.name || 'N/A',
                        Phone: this.connectionPhone(connection),
                        Email: this.connectionEmail(connection),
                        Address: this.connectionAddress(connection),
                    }))
                }
                return exportData
            },
            change({ path, value }) {
                this.changedFields[path] = value
            },
            editEnable(type) {
                switch (type) {
                    case 'profile':
                        this.isProfileEditable = true
                        this.isContactEditable = false
                        this.isAddressEditable = false
                        this.isEmergencyEditable = false
                        this.isPharmacyEditable = false
                        break
                    case 'contact':
                        this.isProfileEditable = false
                        this.isContactEditable = true
                        this.isAddressEditable = false
                        this.isEmergencyEditable = false
                        this.isPharmacyEditable = false
                        break
                    case 'address':
                        this.isContactEditable = false
                        this.isProfileEditable = false
                        this.isAddressEditable = true
                        this.isEmergencyEditable = false
                        this.isPharmacyEditable = false
                        break
                    case 'emergency':
                        this.isContactEditable = false
                        this.isProfileEditable = false
                        this.isAddressEditable = false
                        this.isEmergencyEditable = true
                        this.isPharmacyEditable = false
                        break
                    case 'pharmacy':
                        this.isContactEditable = false
                        this.isProfileEditable = false
                        this.isAddressEditable = false
                        this.isEmergencyEditable = false
                        this.isPharmacyEditable = true
                }
            },
            handleCancel() {
                this.resetEditStates()
            },
            resetEditStates() {
                this.isProfileEditable = false
                this.isContactEditable = false
                this.isAddressEditable = false
                this.isEmergencyEditable = false
                this.isPharmacyEditable = false
            },
            changeLocationAddress(payload) {
                if (!payload?.value) {
                    return
                }
                //eslint-disable-next-line no-undef
                const placesService = new google.maps.places.PlacesService(document.createElement('div'))
                const request = {
                    placeId: payload.value,
                    fields: ['address_components'],
                }

                placesService.getDetails(request, (place, status) => {
                    //eslint-disable-next-line no-undef
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        const addressComponents = {}
                        place.address_components.forEach((component) => {
                            component.types.forEach((type) => {
                                switch (type) {
                                    case 'street_number':
                                        addressComponents.streetNumber = component.long_name
                                        break
                                    case 'route':
                                        addressComponents.address = component.long_name
                                        break
                                    case 'locality':
                                        addressComponents.city = component.long_name
                                        break
                                    case 'administrative_area_level_1':
                                        addressComponents.state = component.short_name
                                        break
                                    case 'postal_code':
                                        addressComponents.zipCode = component.long_name
                                        break
                                }
                            })
                        })

                        this.$set(
                            this.data,
                            'address',
                            `${addressComponents.streetNumber || ''} ${addressComponents.address || ''}`,
                        )
                        this.$set(this.data, 'city', addressComponents.city || '')
                        this.$set(this.data, 'state', addressComponents.state || '')
                        this.$set(this.data, 'zip', addressComponents.zipCode || '')
                        this.isSuggested = true
                    }
                })
            },
            handleFormSubmission() {
                this.isSending = true
                this.emitEvent({ name: 'is-sending', payload: this.isSending })
                const patientId = this.$route.params.id
                let payload = {}
                if (this.isProfileEditable) {
                    if (this.changedFields.fullName) {
                        const [firstName = '', lastName = ''] = this.changedFields.fullName.split(' ')
                        payload.firstName = firstName
                        payload.lastName = lastName
                    }
                    if (this.changedFields.dob) payload.dob = this.changedFields.dob
                    if (this.changedFields.gender) payload.gender = this.changedFields.gender
                    if (this.changedFields.ssn) payload.last4ssn = this.changedFields.ssn
                    if (this.changedFields.maritalStatus) payload.maritalStatus = this.changedFields.maritalStatus
                    if (this.changedFields.language) payload.language = this.changedFields.language
                }

                if (this.isContactEditable) {
                    if (this.changedFields.mobilePhone) payload.mobilePhone = this.changedFields.mobilePhone
                    if (this.changedFields.homePhone) payload.homePhone = this.changedFields.homePhone
                    if (this.changedFields.email) payload.contactEmail = this.changedFields.email
                    if (this.changedFields.preferredContactMethod)
                        payload.preferredContactMethod = this.changedFields.preferredContactMethod
                }

                if (this.isAddressEditable) {
                    payload.address = {
                        address: this.changedFields.address || this.data.address,
                        city: this.changedFields.city || this.data.city,
                        state: this.changedFields.state || this.data.state,
                        zip: this.changedFields.zip || this.data.zip,
                    }
                }

                if (this.isEmergencyEditable) {
                    payload.emergencyContact = {
                        firstName: this.changedFields['emergencyContact.firstName'] || this.data.emergencyContact.firstName,
                        lastName: this.changedFields['emergencyContact.lastName'] || this.data.emergencyContact.lastName,
                        phone: this.changedFields['emergencyContact.phone'] || this.data.emergencyContact.phone,
                        email: this.changedFields['emergencyContact.email'] || this.data.emergencyContact.email,
                        relationship:
                            this.changedFields['emergencyContact.relationship'] || this.data.emergencyContact.relationship,
                    }
                }

                if (this.isPharmacyEditable) {
                    payload.preferredFarmacy = {
                        name: this.changedFields.pharmacyName,
                        address: this.changedFields.pharmacyAddress,
                        city: this.changedFields.city,
                        state: this.changedFields.state,
                        zip: this.changedFields.zip,
                        phone: this.changedFields.pharmacyPhone,
                        fax: this.changedFields.fax,
                    }
                }

                this.handleRequest(PatientAPI.updatePatientDetails(patientId, this.$auth.getUser().id, payload))
                    .then(() => {
                        this.resetEditStates()
                        this.data.address = this.getFullAddress(payload.address)
                    })
                    .finally(() => {
                        this.isSending = false
                        this.emitEvent({ name: 'is-sending', payload: this.isSending })
                        this.resetEditStates()
                    })
            },
            getPatientConnections() {
                const patientId = this.$route.params.id
                PatientAPI.getProviderPatientConnections(patientId, {}, { limit: 3, offset: 0 }).then((res) => {
                    this.connections = res
                })
            },
            connectionName(item) {
                if (item.user) {
                    return `${item.user.designation} ${item.user.firstName} ${item.user.lastName}`
                }
                return item.practice?.name || ''
            },
            connectionPhone(item) {
                if (item.user) {
                    return `${item.user.phone}`
                }
                return item.practice?.phone || 'N/A'
            },
            connectionEmail(item) {
                if (item.user) {
                    return `${item.user.email}`
                }
                return item.practice?.email || ''
            },
            connectionAddress(item) {
                return `${item?.practice?.address}, ${item?.practice?.city}, ${item?.practice?.state} ${item?.practice?.zip}`
            },
            hasEmergencyContact(item) {
                const e = item?.emergencyContact
                return !!(e && (e.firstName || e.lastName))
            },
            setNumberOfItems() {
                if (this.isTablet) {
                    this.maxNumberOfItems = 1
                    return
                }
                if (this.isLaptop) {
                    this.maxNumberOfItems = 2
                    return
                }

                this.maxNumberOfItems = 3
            },
        },

        watch: {
            patientDetails: {
                handler(newVal) {
                    if (newVal && Object.keys(newVal).length) {
                        this.data = {
                            ...this.data,
                            fullName: `${newVal.firstName || ''} ${newVal.lastName || ''}`.trim(),
                            dob: newVal.dateOfBirth || null,
                            gender: newVal?.mcard?.gender || 'N/A',
                            maritalStatus: newVal?.mcard?.maritalStatus || 'N/A',
                            ssn: newVal.ssn || null,
                            language: newVal.language || 'N/A',
                            mobilePhone: newVal?.mobilePhone || null,
                            homePhone: newVal?.homePhone || null,
                            email: newVal.email || 'N/A',
                            address: newVal.address || 'N/A',
                            city: newVal.city || 'N/A',
                            state: newVal.state || 'N/A',
                            zip: newVal.zip || 'N/A',
                            preferredContactMethod: newVal.preferredContactMethod || 'N/A',
                            emergencyContact: {
                                firstName: newVal.mcard?.emergencyContact?.firstName || '',
                                lastName: newVal.mcard?.emergencyContact?.lastName || '',
                                phone: newVal.mcard?.emergencyContact?.phone || '',
                                email: newVal.mcard?.emergencyContact?.email || 'N/A',
                                relationship: newVal.mcard?.emergencyContact?.relationship || 'N/A',
                            },
                        }
                    }
                },
                immediate: true,
                deep: true,
            },
            windowWidth() {
                this.setNumberOfItems()
            },
        },

        mounted() {
            this.setNumberOfItems()
            this.$on('local:afterChange', () => {
                this.emitEvent({ name: 'form-changed', payload: !isEqual(this.initialData, this.data) })
            })
            this.getPatientConnections()
        },
    }
</script>

<style scoped>
    .Cards {
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 20px;
        background: #fff;
    }
    i.check {
        color: #0fa34d;
    }
    .badge {
        border: 1px solid #ddd !important;
        background-color: #fff !important;
        padding: 3px 11px;
        border-radius: 6px;
        color: oklch(0.145 0 0);
    }
    .btn svg {
        margin-right: 12px;
    }
    .btn {
        border: 1px solid #ccc;
        border-radius: 6px;
        padding: 6px 12px;
        cursor: pointer;
        font-size: 13px;
        display: flex;
        align-items: center;
        gap: 6px;
        margin-right: 12px;
    }
    .main {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
    }
    .main-data {
        display: flex;
        align-items: center;
    }
    .port {
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 12px;
        color: oklch(0.145 0 0);
    }
    .card-title {
        font-size: 14px;
        font-weight: 400;
        margin: 6px 6px;
        color: oklch(0.145 0 0);
    }
    .row {
        display: flex;
        flex-wrap: wrap;
        margin: 12px 1px;
    }
    .value {
        margin: 1px 0px;
    }
    .col {
        flex: 1;
        min-width: 200px;
        margin-right: 20px;
    }
    .card_grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }
    .card_grids {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
        margin-top: 12px;
        width: 75%;
    }
    .value {
        font-size: 12px;
        color: oklch(0.145 0 0);
    }
    .label {
        color: oklch(0.446 0.03 256.802);
        font-weight: 500;
    }

    .name {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 14px;
        color: oklch(0.145 0 0);
    }
    .user-name {
        font-weight: 500;
        font-size: 16px;
        color: oklch(0.145 0 0);
    }
    .contact-card {
        border: 1px solid #eee;
        border-radius: 6px;
        padding: 12px;
        margin-bottom: 10px;
    }

    .tag {
        display: inline-block;
        border: 1px solid #ddd;
        padding: 2px 8px;
        border-radius: 7px;
        font-size: 12px;
        margin-right: 5px;
    }

    .tag.primary {
        background: #e3e8ff;
        color: #2f4eff;
    }

    .tag.green {
        background: #e0f7e9;
        color: #1a8f4a;
    }
    @media screen and (max-width: 600px) {
        .col {
            margin-top: 12px;
        }
        .card_grid {
            display: block !important;
        }
        .card_grids {
            grid-template-columns: repeat(2, 1fr);
        }
        .card-grid-title {
            width: 196px;
        }
    }
    .main-card {
        display: flex;
        justify-content: space-between;
    }
    .edit-export {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .title-group {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .export-checkbox {
        margin-left: auto;
    }
    .export-desc {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 8px;
    }
</style>
